<template>
    <div id="contact">
        <Aside />
        <div class="trade">

            <!-- TITRE  -->
            <div class="title">
                <h1>Contactez-nous</h1>
            </div>

            <!-- PANNEAU ERREUR / REUSSITE -->
            <div class="errorpanel" v-if="errors.length || success.length" @click="errors = []">
                <div class="close">X</div>
                <div v-if="errors && errors.length" class="error">
                    <ul>
                        <li v-for="error in errors" :key="error" v-html="error"></li>
                    </ul>
                </div>
                <p v-if="success && success.length" class="success" @click="success = []">
                    <ul>
                        <li v-for="yes in success" :key="yes" v-html="yes"></li>
                    </ul>
                </p>
            </div>

            
            <div class="container">
                <!-- FORMULAIRE -->
                <div class="form">
                    <div class="inputForm">
                        <label for="lastname">* Nom</label>
                        <input type="text" v-model="lastnameContact">
                    </div>
                    <div class="inputForm">
                        <label for="firstname">* Prénom</label>
                        <input type="text" v-model="firstnameContact">
                    </div>
                    <div class="inputForm">
                        <label for="email">* Email</label>
                        <input type="text" v-model="emailContact">
                    </div>
                    <div class="inputForm">
                        <label for="subject">* Sujet</label>
                        <input type="text" v-model="subjectContact">
                    </div>
                    <div class="inputForm">
                        <label for="message">* Message</label>
                        <textarea name="message" id="message" cols="30" rows="10" v-model="messageContact"></textarea>
                    </div>
                    <div class="checkForm">
                        <input type="checkbox" name="acceptInfosConditionUse" id="acceptInfosConditionUse" v-model="acceptInfosConditionUseContact" @click="acceptInfosConditionUseContact = !acceptInfosConditionUseContact">
                        <p>* En cochant cette case, j'accepte que les informations saisies soient exploitées dans le cadre d'une demande d'information.</p>
                    </div>
                    <div class="sendForm">
                        <a class="blackBtn" @click="checkForm()">Envoyer</a>
                    </div>
                </div>

                <!-- COORDONNEES -->
                <div class="contactInfo">
                    <div class="content">
                        <h2>Coordonnées</h2>
                        
                        <p>{{ adress }}</p>
                        <p>{{ postalCode }}</p>
                        <!-- <p>{{ phone }}</p> -->
                        <a
                        href="https://www.facebook.com/tousensemble.asso.commercants.gimont/"
                        target="_blank"
                        rel="noopener"
                        >
                            <i class="fab fa-facebook"></i>
                        </a>
                        
                        <!-- <iframe src="https://app.panneaupocket.com/embeded/1884318079" height="518" width="300" frameborder="0"></iframe> -->
                    </div>
                    <div class="img">
                        <img src="../assets/img/content/gimontmap.png" alt="Dessin carte Gimont">
                    </div>
                </div>
            </div>

            <!-- BOUTON RETOUR -->
            <div class="fullBtn">
                <router-link to="/" class="backBtn">Accueil</router-link>
            </div>
        </div>
        
    </div>
</template>

<script>
import { titleMixin } from "../mixins/titleMixin";
import { formMixin } from "../mixins/formMixin";
import Aside from "../components/Aside";
import axios from "axios";

export default {
  metaInfo: {
    meta: [
      {
        vmid: "description",
        name: "description",
        // content: "Sécuriser votre capital et accompagner vos projets de développement. Protéger votre environnement.Préserver vos installations, vos appareils. Renforcer la prévention pour l'accueil du public. Lab'eau, laboratoire d'hygiène et environnement dans le Tarn-et-Garonne."
        content:
          "Contactez nous pour toutes demandes... Vie économiques gimontoise à Gimont dans le Gers",
      },
      {
        vmid: "keywords",
        name: "keywords",
        // content: "Environnement, Hygiène, Analyses d'air, Analyses d'eau, Analyses d'hygiène, Laboratoire, Lab'Eau, Tarn-et-Garonne"
        content:
          "Vie économique, Partenaires gimontois, Commerces, Producteurs locaux, Artisans, Vie économique gimontoise, Gimont, Gers",
      },
    ],
  },
  name: "Contact",
  components: {
    Aside,
  },
  mixins: [titleMixin, formMixin],
  data() {
    return {
      title: "Contactez-nous Vie économique gimontoise Gimont Gers 32",
      lastnameContact: "",
      firstnameContact: "",
      emailContact: "",
      subjectContact: "",
      messageContact: "",
      acceptInfosConditionUseContact: 0,

      adress: "85 Rue nationale",
      postalCode: "32200 GIMONT",
      phone: "05.01.02.03.04",
      success: [],
      errors: [],
    };
  },
  methods: {
    checkForm: function () {
      // if required fields are set
      if (
        this.lastnameContact &&
        this.firstnameContact &&
        this.emailContact &&
        this.emailIsvalid(this.emailContact) &&
        this.subjectContact &&
        this.messageContact &&
        this.acceptInfosConditionUseContact
      ) {
        // let value = this.prepareMail();
        this.sendMail();
        this.success.push(
          "Votre email a bien été envoyé. Nous vous recontacterons dans les meilleurs délais"
        );
        return true;
      } else {
        this.errors = [];
        this.errors.push(
          "<b>Avant d'envoyer votre demande, vous devez remplir les champs suivants :</b>"
        );
        if (!this.lastnameContact) {
          this.errors.push("Nom");
        }
        if (!this.firstnameContact) {
          this.errors.push("Prénom");
        }
        if (!this.emailContact) {
          this.errors.push("Email");
        }
        if (!this.emailIsvalid(this.emailContact)) {
          this.errors.push("Email invalide");
        }
        if (!this.subjectContact) {
          this.errors.push("Sujet du message");
        }
        if (!this.messageContact) {
          this.errors.push("Message");
        }
        if (!this.acceptInfosConditionUseContact) {
          this.errors.push(
            "Vous devez accepter les conditions d'utilisations."
          );
        }
      }
    },

    sendMail() {
      axios
        .post(
          "/contact.aspx",
          {
            contact: this.emailContact,
            nom: this.lastnameContact,
            prenom: this.firstnameContact,
            sujet: this.subjectContact,
            message: this.messageContact,
          },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then(function (response) {
          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.trade .container {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 2rem;
}
.trade .container .form {
  width: 50%;
  border-right: 1px solid #f3d6b2;
}
.trade .container .form .inputForm {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
}
.trade .container .form .inputForm input {
  width: 81%;
  padding: 0.5rem 0;
  border: 1px lightgray solid;
  border-radius: 8px;
}
.trade .container .form .inputForm input,
.trade .container .form .inputForm textarea,
.trade .container .form .checkForm input[type="checkbox"] {
  border: 1px lightgray solid;
  border-radius: 8px;
  margin-left: 1rem;
}
.trade .container .form .inputForm input:focus,
.trade .container .form .inputForm textarea:focus,
.trade .container .form .checkForm input[type="checkbox"]:focus {
  outline: none !important;
  border: 1px solid #f3d6b2;
  box-shadow: 0px 0px 5px #d89747;
}
.trade .container .form .inputForm label {
  margin-bottom: 0.3rem;
}
.trade .container .form .checkForm {
  display: flex;
  align-items: center;
}
.trade .container .form .checkForm p {
  width: 80%;
  font-size: 0.8rem;
}
.trade .container .form .sendForm {
  margin-top: 1rem;
}
.trade .container .contactInfo {
  width: 40%;
}
.trade .container .contactInfo h2 {
  text-align: left;
  color: #d89747;
}
.trade .container .contactInfo p,
.trade .container .contactInfo a {
  margin-left: 1rem;
}
.trade .container .contactInfo img {
  margin-top: 2rem;
  width: 80%;
}

.trade .fa-facebook {
  color: #3b5998;
  font-size: 1.5rem;
  transition: all 0.5s ease;
}

.trade .fa-facebook:hover {
  color: #d89747;
  transition: all 0.5s ease;
}

@media all and (max-width: 1000px) {
  .trade .container {
    display: flex;
    flex-direction: column-reverse;
  }
  .trade .container .contactInfo {
    width: 100%;
    display: flex;
    align-items: center;
  }
  .trade .container .contactInfo .content {
    width: 60%;
  }
  .trade .container .contactInfo .img {
    width: 40%;
  }
  .trade .container .contactInfo .img img {
    margin: 0;
    width: 100%;
  }
  .trade .container .form {
    width: 100%;
    border-right: none;
    border-top: 1px solid #f3d6b2;
    margin-top: 1.5rem;
    padding-top: 1.5rem;
  }
}
@media all and (max-width: 768px) {
  .trade .container .form .inputForm input {
    width: 91%;
  }
}
@media all and (max-width: 400px) {
  .trade .container .contactInfo,
  .trade .container .form {
    width: 100%;
  }
  .trade .container .contactInfo .content {
    width: 100%;
  }
  .trade .container .contactInfo .img {
    display: none;
  }
}
</style>